import { Action, createReducer, on } from '@ngrx/store';
import * as GamesActions from '@app/core/store/games/games-actions';
import { Game } from '@app/games/model/game';

export interface State {
  games: Game[];
  gamesLoaded: boolean;
}

export const initialState: State = {
  games: [],
  gamesLoaded: false,
};

export const reducers = createReducer(initialState,
  on(GamesActions.gamesLoaded, (state: State, { games }) => ({ games, gamesLoaded: true })),
);

export function reducer(state: State | undefined, action: Action): State {
  return reducers(state, action);
}
